/* tslint:disable */
/* eslint-disable */
/**
 * Resell Search
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from "./base";

/**
 *
 * @export
 * @interface BaseSearchValue
 */
export interface BaseSearchValue {
  values: any;
  /**
   *
   * @type {number}
   * @memberof BaseSearchValue
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof BaseSearchValue
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof BaseSearchValue
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CatalogProductDetailDto
 */
export interface CatalogProductDetailDto {
  /**
   *
   * @type {number}
   * @memberof CatalogProductDetailDto
   */
  catalogId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  sku?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  year?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  productName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  colorLabel?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  collection?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  frontImage?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  shortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  longDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  composition?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CatalogProductDetailDto
   */
  attributes?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof CatalogProductDetailDto
   */
  priceValue?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogProductDetailDto
   */
  priceCurrency?: string;
  /**
   *
   * @type {Array<ProductOptionValueDto>}
   * @memberof CatalogProductDetailDto
   */
  availableSizes?: Array<ProductOptionValueDto>;
}
/**
 *
 * @export
 * @interface CatalogProductListDto
 */
export interface CatalogProductListDto {
  /**
   *
   * @type {number}
   * @memberof CatalogProductListDto
   */
  catalogId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogProductListDto
   */
  sku?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductListDto
   */
  year?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductListDto
   */
  productName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductListDto
   */
  colorLabel?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductListDto
   */
  collection?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogProductListDto
   */
  frontImage?: string;
}
/**
 *
 * @export
 * @interface CustomerDto
 */
export interface CustomerDto {
  /**
   *
   * @type {number}
   * @memberof CustomerDto
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof CustomerDto
   */
  nickname?: string;
  /**
   *
   * @type {number}
   * @memberof CustomerDto
   */
  averageRating?: number;
  /**
   *
   * @type {RatingsDto}
   * @memberof CustomerDto
   */
  ratings?: RatingsDto;
}
/**
 *
 * @export
 * @interface GridSummaryDto
 */
export interface GridSummaryDto {
  /**
   *
   * @type {number}
   * @memberof GridSummaryDto
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof GridSummaryDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GridSummaryDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof GridSummaryDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GridSummaryDto
   */
  rank?: string;
  /**
   *
   * @type {boolean}
   * @memberof GridSummaryDto
   */
  default?: boolean;
}
/**
 *
 * @export
 * @interface PageCatalogProductListDto
 */
export interface PageCatalogProductListDto {
  /**
   *
   * @type {number}
   * @memberof PageCatalogProductListDto
   */
  totalElements?: number;
  /**
   *
   * @type {number}
   * @memberof PageCatalogProductListDto
   */
  totalPages?: number;
  /**
   *
   * @type {PageableObject}
   * @memberof PageCatalogProductListDto
   */
  pageable?: PageableObject;
  /**
   *
   * @type {number}
   * @memberof PageCatalogProductListDto
   */
  size?: number;
  /**
   *
   * @type {Array<CatalogProductListDto>}
   * @memberof PageCatalogProductListDto
   */
  content?: Array<CatalogProductListDto>;
  /**
   *
   * @type {number}
   * @memberof PageCatalogProductListDto
   */
  number?: number;
  /**
   *
   * @type {Sort}
   * @memberof PageCatalogProductListDto
   */
  sort?: Sort;
  /**
   *
   * @type {number}
   * @memberof PageCatalogProductListDto
   */
  numberOfElements?: number;
  /**
   *
   * @type {boolean}
   * @memberof PageCatalogProductListDto
   */
  first?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageCatalogProductListDto
   */
  last?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageCatalogProductListDto
   */
  empty?: boolean;
}
/**
 *
 * @export
 * @interface PageGridSummaryDto
 */
export interface PageGridSummaryDto {
  /**
   *
   * @type {number}
   * @memberof PageGridSummaryDto
   */
  totalElements?: number;
  /**
   *
   * @type {number}
   * @memberof PageGridSummaryDto
   */
  totalPages?: number;
  /**
   *
   * @type {PageableObject}
   * @memberof PageGridSummaryDto
   */
  pageable?: PageableObject;
  /**
   *
   * @type {number}
   * @memberof PageGridSummaryDto
   */
  size?: number;
  /**
   *
   * @type {Array<GridSummaryDto>}
   * @memberof PageGridSummaryDto
   */
  content?: Array<GridSummaryDto>;
  /**
   *
   * @type {number}
   * @memberof PageGridSummaryDto
   */
  number?: number;
  /**
   *
   * @type {Sort}
   * @memberof PageGridSummaryDto
   */
  sort?: Sort;
  /**
   *
   * @type {number}
   * @memberof PageGridSummaryDto
   */
  numberOfElements?: number;
  /**
   *
   * @type {boolean}
   * @memberof PageGridSummaryDto
   */
  first?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageGridSummaryDto
   */
  last?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageGridSummaryDto
   */
  empty?: boolean;
}
/**
 *
 * @export
 * @interface PageProduct
 */
export interface PageProduct {
  /**
   *
   * @type {number}
   * @memberof PageProduct
   */
  totalElements?: number;
  /**
   *
   * @type {number}
   * @memberof PageProduct
   */
  totalPages?: number;
  /**
   *
   * @type {PageableObject}
   * @memberof PageProduct
   */
  pageable?: PageableObject;
  /**
   *
   * @type {number}
   * @memberof PageProduct
   */
  size?: number;
  /**
   *
   * @type {Array<Product>}
   * @memberof PageProduct
   */
  content?: Array<Product>;
  /**
   *
   * @type {number}
   * @memberof PageProduct
   */
  number?: number;
  /**
   *
   * @type {Sort}
   * @memberof PageProduct
   */
  sort?: Sort;
  /**
   *
   * @type {number}
   * @memberof PageProduct
   */
  numberOfElements?: number;
  /**
   *
   * @type {boolean}
   * @memberof PageProduct
   */
  first?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageProduct
   */
  last?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageProduct
   */
  empty?: boolean;
}
/**
 *
 * @export
 * @interface PageUniverseDto
 */
export interface PageUniverseDto {
  /**
   *
   * @type {number}
   * @memberof PageUniverseDto
   */
  totalElements?: number;
  /**
   *
   * @type {number}
   * @memberof PageUniverseDto
   */
  totalPages?: number;
  /**
   *
   * @type {PageableObject}
   * @memberof PageUniverseDto
   */
  pageable?: PageableObject;
  /**
   *
   * @type {number}
   * @memberof PageUniverseDto
   */
  size?: number;
  /**
   *
   * @type {Array<UniverseDto>}
   * @memberof PageUniverseDto
   */
  content?: Array<UniverseDto>;
  /**
   *
   * @type {number}
   * @memberof PageUniverseDto
   */
  number?: number;
  /**
   *
   * @type {Sort}
   * @memberof PageUniverseDto
   */
  sort?: Sort;
  /**
   *
   * @type {number}
   * @memberof PageUniverseDto
   */
  numberOfElements?: number;
  /**
   *
   * @type {boolean}
   * @memberof PageUniverseDto
   */
  first?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageUniverseDto
   */
  last?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageUniverseDto
   */
  empty?: boolean;
}
/**
 *
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  pageNumber?: number;
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  pageSize?: number;
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  offset?: number;
  /**
   *
   * @type {Sort}
   * @memberof PageableObject
   */
  sort?: Sort;
  /**
   *
   * @type {boolean}
   * @memberof PageableObject
   */
  paged?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageableObject
   */
  unpaged?: boolean;
}
/**
 *
 * @export
 * @interface Product
 */
export interface Product {
  /**
   *
   * @type {number}
   * @memberof Product
   */
  sellerId?: number;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  sellerShortName?: string;
  /**
   *
   * @type {CustomerDto}
   * @memberof Product
   */
  seller?: CustomerDto;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  catalogId?: number;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  catalogTitle?: string;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  catalogShortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  catalogColorLabel?: string;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  catalogComposition?: string;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  frontImage?: string;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  categoryId?: number;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  sizeId?: number;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  colorId?: number;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  conditionId?: number;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  sku?: string;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  yearOfPurchase?: number;
  /**
   *
   * @type {ProductPriceDto}
   * @memberof Product
   */
  price?: ProductPriceDto;
  /**
   *
   * @type {Array<string>}
   * @memberof Product
   */
  imageUrls?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  publicationDate?: string;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  sortOrder?: number;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  rank?: string;
  /**
   *
   * @type {boolean}
   * @memberof Product
   */
  manualEntry?: boolean;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  catalogDescription?: string;
}
/**
 *
 * @export
 * @interface ProductOptionValueDto
 */
export interface ProductOptionValueDto {
  /**
   *
   * @type {number}
   * @memberof ProductOptionValueDto
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ProductOptionValueDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ProductOptionValueDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof ProductOptionValueDto
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof ProductOptionValueDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof ProductOptionValueDto
   */
  extra?: string;
  /**
   *
   * @type {boolean}
   * @memberof ProductOptionValueDto
   */
  disabled?: boolean;
}
/**
 *
 * @export
 * @interface ProductPriceDto
 */
export interface ProductPriceDto {
  /**
   *
   * @type {string}
   * @memberof ProductPriceDto
   */
  currency?: string;
  /**
   *
   * @type {number}
   * @memberof ProductPriceDto
   */
  value?: number;
  /**
   *
   * @type {number}
   * @memberof ProductPriceDto
   */
  exponent?: number;
}
/**
 *
 * @export
 * @interface RatingsDto
 */
export interface RatingsDto {
  /**
   *
   * @type {number}
   * @memberof RatingsDto
   */
  productRating?: number;
  /**
   *
   * @type {number}
   * @memberof RatingsDto
   */
  sellerRating?: number;
  /**
   *
   * @type {number}
   * @memberof RatingsDto
   */
  shippingRating?: number;
  /**
   *
   * @type {number}
   * @memberof RatingsDto
   */
  autoRating?: number;
  /**
   *
   * @type {number}
   * @memberof RatingsDto
   */
  totalRatings?: number;
  /**
   *
   * @type {number}
   * @memberof RatingsDto
   */
  totalAutoRatings?: number;
}
/**
 *
 * @export
 * @interface SearchFieldsDto
 */
export interface SearchFieldsDto {
  /**
   *
   * @type {string}
   * @memberof SearchFieldsDto
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof SearchFieldsDto
   */
  categoryName?: string;
  /**
   *
   * @type {Array<BaseSearchValue>}
   * @memberof SearchFieldsDto
   */
  values?: Array<BaseSearchValue>;
  /**
   *
   * @type {string}
   * @memberof SearchFieldsDto
   */
  fieldName?: string;
}
/**
 *
 * @export
 * @interface SearchOptionsDto
 */
export interface SearchOptionsDto {
  /**
   *
   * @type {Array<SearchSortDto>}
   * @memberof SearchOptionsDto
   */
  sorting?: Array<SearchSortDto>;
  /**
   *
   * @type {Array<SearchFieldsDto>}
   * @memberof SearchOptionsDto
   */
  filters?: Array<SearchFieldsDto>;
}
/**
 *
 * @export
 * @interface SearchSortDto
 */
export interface SearchSortDto {
  /**
   *
   * @type {string}
   * @memberof SearchSortDto
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof SearchSortDto
   */
  categoryName?: string;
  /**
   *
   * @type {string}
   * @memberof SearchSortDto
   */
  fieldName?: string;
}
/**
 *
 * @export
 * @interface Sort
 */
export interface Sort {
  /**
   *
   * @type {boolean}
   * @memberof Sort
   */
  sorted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Sort
   */
  empty?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Sort
   */
  unsorted?: boolean;
}
/**
 *
 * @export
 * @interface StoreInfoDto
 */
export interface StoreInfoDto {
  /**
   *
   * @type {number}
   * @memberof StoreInfoDto
   */
  itxId: number;
  /**
   *
   * @type {string}
   * @memberof StoreInfoDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof StoreInfoDto
   */
  defaultLanguage: string;
  /**
   *
   * @type {Array<string>}
   * @memberof StoreInfoDto
   */
  languages: Array<string>;
}
/**
 *
 * @export
 * @interface UniverseDto
 */
export interface UniverseDto {
  /**
   *
   * @type {number}
   * @memberof UniverseDto
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof UniverseDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UniverseDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof UniverseDto
   */
  description?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof UniverseDto
   */
  categories?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof UniverseDto
   */
  rank?: string;
  /**
   *
   * @type {Array<GridSummaryDto>}
   * @memberof UniverseDto
   */
  grids?: Array<GridSummaryDto>;
  /**
   *
   * @type {boolean}
   * @memberof UniverseDto
   */
  default?: boolean;
}

/**
 * SearchGridAPIApi - axios parameter creator
 * @export
 */
export const SearchGridAPIApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGridSummaryById: async (
      id: number,
      storeId: number,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("getGridSummaryById", "id", id);
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("getGridSummaryById", "storeId", storeId);
      const localVarPath = `/api/v1/search/grid-summary/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get grid list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gridSummary: async (
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("gridSummary", "storeId", storeId);
      const localVarPath = `/api/v1/search/grid-summary`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search a product by query
     * @param {number} gridId
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProduct1: async (
      gridId: number,
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'gridId' is not null or undefined
      assertParamExists("searchProduct1", "gridId", gridId);
      // verify required parameter 'query' is not null or undefined
      assertParamExists("searchProduct1", "query", query);
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("searchProduct1", "storeId", storeId);
      const localVarPath = `/api/v1/search/grid/{gridId}/search`.replace(
        `{${"gridId"}}`,
        encodeURIComponent(String(gridId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (query !== undefined) {
        localVarQueryParameter["query"] = query;
      }

      if (minPrice !== undefined) {
        localVarQueryParameter["minPrice"] = minPrice;
      }

      if (maxPrice !== undefined) {
        localVarQueryParameter["maxPrice"] = maxPrice;
      }

      if (manualEntry !== undefined) {
        localVarQueryParameter["manualEntry"] = manualEntry;
      }

      if (minPublicationDateInMillis !== undefined) {
        localVarQueryParameter["minPublicationDateInMillis"] =
          minPublicationDateInMillis;
      }

      if (maxPublicationDateInMillis !== undefined) {
        localVarQueryParameter["maxPublicationDateInMillis"] =
          maxPublicationDateInMillis;
      }

      if (universeId) {
        localVarQueryParameter["universeId"] = universeId;
      }

      if (colorId) {
        localVarQueryParameter["colorId"] = colorId;
      }

      if (categoryId) {
        localVarQueryParameter["categoryId"] = categoryId;
      }

      if (sizeId) {
        localVarQueryParameter["sizeId"] = sizeId;
      }

      if (conditionId) {
        localVarQueryParameter["conditionId"] = conditionId;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search a product by query bypassing the cache
     * @param {number} gridId
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProductWithoutCache1: async (
      gridId: number,
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'gridId' is not null or undefined
      assertParamExists("searchProductWithoutCache1", "gridId", gridId);
      // verify required parameter 'query' is not null or undefined
      assertParamExists("searchProductWithoutCache1", "query", query);
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("searchProductWithoutCache1", "storeId", storeId);
      const localVarPath =
        `/api/v1/search/no-cache/grid/{gridId}/search`.replace(
          `{${"gridId"}}`,
          encodeURIComponent(String(gridId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (query !== undefined) {
        localVarQueryParameter["query"] = query;
      }

      if (minPrice !== undefined) {
        localVarQueryParameter["minPrice"] = minPrice;
      }

      if (maxPrice !== undefined) {
        localVarQueryParameter["maxPrice"] = maxPrice;
      }

      if (manualEntry !== undefined) {
        localVarQueryParameter["manualEntry"] = manualEntry;
      }

      if (minPublicationDateInMillis !== undefined) {
        localVarQueryParameter["minPublicationDateInMillis"] =
          minPublicationDateInMillis;
      }

      if (maxPublicationDateInMillis !== undefined) {
        localVarQueryParameter["maxPublicationDateInMillis"] =
          maxPublicationDateInMillis;
      }

      if (universeId) {
        localVarQueryParameter["universeId"] = universeId;
      }

      if (colorId) {
        localVarQueryParameter["colorId"] = colorId;
      }

      if (categoryId) {
        localVarQueryParameter["categoryId"] = categoryId;
      }

      if (sizeId) {
        localVarQueryParameter["sizeId"] = sizeId;
      }

      if (conditionId) {
        localVarQueryParameter["conditionId"] = conditionId;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SearchGridAPIApi - functional programming interface
 * @export
 */
export const SearchGridAPIApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SearchGridAPIApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGridSummaryById(
      id: number,
      storeId: number,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridSummaryDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getGridSummaryById(
          id,
          storeId,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get grid list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gridSummary(
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageGridSummaryDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gridSummary(
        storeId,
        page,
        size,
        sort,
        lang,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Search a product by query
     * @param {number} gridId
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchProduct1(
      gridId: number,
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchProduct1(
        gridId,
        query,
        storeId,
        minPrice,
        maxPrice,
        manualEntry,
        minPublicationDateInMillis,
        maxPublicationDateInMillis,
        universeId,
        colorId,
        categoryId,
        sizeId,
        conditionId,
        page,
        size,
        sort,
        lang,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Search a product by query bypassing the cache
     * @param {number} gridId
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchProductWithoutCache1(
      gridId: number,
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.searchProductWithoutCache1(
          gridId,
          query,
          storeId,
          minPrice,
          maxPrice,
          manualEntry,
          minPublicationDateInMillis,
          maxPublicationDateInMillis,
          universeId,
          colorId,
          categoryId,
          sizeId,
          conditionId,
          page,
          size,
          sort,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * SearchGridAPIApi - factory interface
 * @export
 */
export const SearchGridAPIApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SearchGridAPIApiFp(configuration);
  return {
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGridSummaryById(
      id: number,
      storeId: number,
      lang?: string,
      options?: any,
    ): AxiosPromise<GridSummaryDto> {
      return localVarFp
        .getGridSummaryById(id, storeId, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get grid list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gridSummary(
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageGridSummaryDto> {
      return localVarFp
        .gridSummary(storeId, page, size, sort, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search a product by query
     * @param {number} gridId
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProduct1(
      gridId: number,
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageProduct> {
      return localVarFp
        .searchProduct1(
          gridId,
          query,
          storeId,
          minPrice,
          maxPrice,
          manualEntry,
          minPublicationDateInMillis,
          maxPublicationDateInMillis,
          universeId,
          colorId,
          categoryId,
          sizeId,
          conditionId,
          page,
          size,
          sort,
          lang,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search a product by query bypassing the cache
     * @param {number} gridId
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProductWithoutCache1(
      gridId: number,
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageProduct> {
      return localVarFp
        .searchProductWithoutCache1(
          gridId,
          query,
          storeId,
          minPrice,
          maxPrice,
          manualEntry,
          minPublicationDateInMillis,
          maxPublicationDateInMillis,
          universeId,
          colorId,
          categoryId,
          sizeId,
          conditionId,
          page,
          size,
          sort,
          lang,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SearchGridAPIApi - interface
 * @export
 * @interface SearchGridAPIApi
 */
export interface SearchGridAPIApiInterface {
  /**
   *
   * @summary Get a product by id
   * @param {number} id
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchGridAPIApiInterface
   */
  getGridSummaryById(
    id: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<GridSummaryDto>;

  /**
   *
   * @summary Get grid list
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchGridAPIApiInterface
   */
  gridSummary(
    storeId: number,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageGridSummaryDto>;

  /**
   *
   * @summary Search a product by query
   * @param {number} gridId
   * @param {string} query
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [minPrice]
   * @param {number} [maxPrice]
   * @param {boolean} [manualEntry]
   * @param {number} [minPublicationDateInMillis]
   * @param {number} [maxPublicationDateInMillis]
   * @param {Array<number>} [universeId]
   * @param {Array<number>} [colorId]
   * @param {Array<number>} [categoryId]
   * @param {Array<number>} [sizeId]
   * @param {Array<number>} [conditionId]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchGridAPIApiInterface
   */
  searchProduct1(
    gridId: number,
    query: string,
    storeId: number,
    minPrice?: number,
    maxPrice?: number,
    manualEntry?: boolean,
    minPublicationDateInMillis?: number,
    maxPublicationDateInMillis?: number,
    universeId?: Array<number>,
    colorId?: Array<number>,
    categoryId?: Array<number>,
    sizeId?: Array<number>,
    conditionId?: Array<number>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageProduct>;

  /**
   *
   * @summary Search a product by query bypassing the cache
   * @param {number} gridId
   * @param {string} query
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [minPrice]
   * @param {number} [maxPrice]
   * @param {boolean} [manualEntry]
   * @param {number} [minPublicationDateInMillis]
   * @param {number} [maxPublicationDateInMillis]
   * @param {Array<number>} [universeId]
   * @param {Array<number>} [colorId]
   * @param {Array<number>} [categoryId]
   * @param {Array<number>} [sizeId]
   * @param {Array<number>} [conditionId]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchGridAPIApiInterface
   */
  searchProductWithoutCache1(
    gridId: number,
    query: string,
    storeId: number,
    minPrice?: number,
    maxPrice?: number,
    manualEntry?: boolean,
    minPublicationDateInMillis?: number,
    maxPublicationDateInMillis?: number,
    universeId?: Array<number>,
    colorId?: Array<number>,
    categoryId?: Array<number>,
    sizeId?: Array<number>,
    conditionId?: Array<number>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageProduct>;
}

/**
 * SearchGridAPIApi - object-oriented interface
 * @export
 * @class SearchGridAPIApi
 * @extends {BaseAPI}
 */
export class SearchGridAPIApi
  extends BaseAPI
  implements SearchGridAPIApiInterface
{
  /**
   *
   * @summary Get a product by id
   * @param {number} id
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchGridAPIApi
   */
  public getGridSummaryById(
    id: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchGridAPIApiFp(this.configuration)
      .getGridSummaryById(id, storeId, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get grid list
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchGridAPIApi
   */
  public gridSummary(
    storeId: number,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchGridAPIApiFp(this.configuration)
      .gridSummary(storeId, page, size, sort, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search a product by query
   * @param {number} gridId
   * @param {string} query
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [minPrice]
   * @param {number} [maxPrice]
   * @param {boolean} [manualEntry]
   * @param {number} [minPublicationDateInMillis]
   * @param {number} [maxPublicationDateInMillis]
   * @param {Array<number>} [universeId]
   * @param {Array<number>} [colorId]
   * @param {Array<number>} [categoryId]
   * @param {Array<number>} [sizeId]
   * @param {Array<number>} [conditionId]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchGridAPIApi
   */
  public searchProduct1(
    gridId: number,
    query: string,
    storeId: number,
    minPrice?: number,
    maxPrice?: number,
    manualEntry?: boolean,
    minPublicationDateInMillis?: number,
    maxPublicationDateInMillis?: number,
    universeId?: Array<number>,
    colorId?: Array<number>,
    categoryId?: Array<number>,
    sizeId?: Array<number>,
    conditionId?: Array<number>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchGridAPIApiFp(this.configuration)
      .searchProduct1(
        gridId,
        query,
        storeId,
        minPrice,
        maxPrice,
        manualEntry,
        minPublicationDateInMillis,
        maxPublicationDateInMillis,
        universeId,
        colorId,
        categoryId,
        sizeId,
        conditionId,
        page,
        size,
        sort,
        lang,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search a product by query bypassing the cache
   * @param {number} gridId
   * @param {string} query
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [minPrice]
   * @param {number} [maxPrice]
   * @param {boolean} [manualEntry]
   * @param {number} [minPublicationDateInMillis]
   * @param {number} [maxPublicationDateInMillis]
   * @param {Array<number>} [universeId]
   * @param {Array<number>} [colorId]
   * @param {Array<number>} [categoryId]
   * @param {Array<number>} [sizeId]
   * @param {Array<number>} [conditionId]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchGridAPIApi
   */
  public searchProductWithoutCache1(
    gridId: number,
    query: string,
    storeId: number,
    minPrice?: number,
    maxPrice?: number,
    manualEntry?: boolean,
    minPublicationDateInMillis?: number,
    maxPublicationDateInMillis?: number,
    universeId?: Array<number>,
    colorId?: Array<number>,
    categoryId?: Array<number>,
    sizeId?: Array<number>,
    conditionId?: Array<number>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchGridAPIApiFp(this.configuration)
      .searchProductWithoutCache1(
        gridId,
        query,
        storeId,
        minPrice,
        maxPrice,
        manualEntry,
        minPublicationDateInMillis,
        maxPublicationDateInMillis,
        universeId,
        colorId,
        categoryId,
        sizeId,
        conditionId,
        page,
        size,
        sort,
        lang,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SearchProductAPIApi - axios parameter creator
 * @export
 */
export const SearchProductAPIApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductById: async (
      id: number,
      storeId: number,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("getProductById", "id", id);
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("getProductById", "storeId", storeId);
      const localVarPath = `/api/v1/search/product/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductById1: async (
      id: number,
      storeId: number,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("getProductById1", "id", id);
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("getProductById1", "storeId", storeId);
      const localVarPath = `/api/v1/search/catalog/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get filters for products
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId]
     * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductSearchOptions: async (
      storeId: number,
      universeId?: number,
      showDisabled?: boolean,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("getProductSearchOptions", "storeId", storeId);
      const localVarPath = `/api/v1/search/filters/for-products`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (universeId !== undefined) {
        localVarQueryParameter["universeId"] = universeId;
      }

      if (showDisabled !== undefined) {
        localVarQueryParameter["showDisabled"] = showDisabled;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get filters for products by gridId
     * @param {number} gridId
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductSearchOptionsByGrid: async (
      gridId: number,
      storeId: number,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'gridId' is not null or undefined
      assertParamExists("getProductSearchOptionsByGrid", "gridId", gridId);
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("getProductSearchOptionsByGrid", "storeId", storeId);
      const localVarPath =
        `/api/v1/search/filters/for-products/by-grid/{gridId}`.replace(
          `{${"gridId"}}`,
          encodeURIComponent(String(gridId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get filters for products by universeId
     * @param {number} universeId
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductSearchOptionsByUniverse: async (
      universeId: number,
      storeId: number,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'universeId' is not null or undefined
      assertParamExists(
        "getProductSearchOptionsByUniverse",
        "universeId",
        universeId,
      );
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists(
        "getProductSearchOptionsByUniverse",
        "storeId",
        storeId,
      );
      const localVarPath =
        `/api/v1/search/filters/for-products/by-universe/{universeId}`.replace(
          `{${"universeId"}}`,
          encodeURIComponent(String(universeId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get available products list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAvailableProducts: async (
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("listAvailableProducts", "storeId", storeId);
      const localVarPath = `/api/v1/search/products`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get available products list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAvailableProducts1: async (
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("listAvailableProducts1", "storeId", storeId);
      const localVarPath = `/api/v1/search/catalog`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get products by SKU list
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<string>} [skus]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProductsBySku: async (
      storeId: number,
      skus?: Array<string>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("listProductsBySku", "storeId", storeId);
      const localVarPath = `/api/v1/search/catalog/by/sku`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (skus) {
        localVarQueryParameter["skus"] = skus;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search a product by query
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProduct: async (
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists("searchProduct", "query", query);
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("searchProduct", "storeId", storeId);
      const localVarPath = `/api/v1/search/products/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (query !== undefined) {
        localVarQueryParameter["query"] = query;
      }

      if (minPrice !== undefined) {
        localVarQueryParameter["minPrice"] = minPrice;
      }

      if (maxPrice !== undefined) {
        localVarQueryParameter["maxPrice"] = maxPrice;
      }

      if (manualEntry !== undefined) {
        localVarQueryParameter["manualEntry"] = manualEntry;
      }

      if (minPublicationDateInMillis !== undefined) {
        localVarQueryParameter["minPublicationDateInMillis"] =
          minPublicationDateInMillis;
      }

      if (maxPublicationDateInMillis !== undefined) {
        localVarQueryParameter["maxPublicationDateInMillis"] =
          maxPublicationDateInMillis;
      }

      if (universeId) {
        localVarQueryParameter["universeId"] = universeId;
      }

      if (colorId) {
        localVarQueryParameter["colorId"] = colorId;
      }

      if (categoryId) {
        localVarQueryParameter["categoryId"] = categoryId;
      }

      if (sizeId) {
        localVarQueryParameter["sizeId"] = sizeId;
      }

      if (conditionId) {
        localVarQueryParameter["conditionId"] = conditionId;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search a product by query
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query]
     * @param {string} [sku]
     * @param {string} [color]
     * @param {string} [model]
     * @param {string} [quality]
     * @param {string} [year]
     * @param {string} [campaign]
     * @param {number} [catalogId]
     * @param {string} [qrUrl]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProduct2: async (
      storeId: number,
      query?: string,
      sku?: string,
      color?: string,
      model?: string,
      quality?: string,
      year?: string,
      campaign?: string,
      catalogId?: number,
      qrUrl?: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("searchProduct2", "storeId", storeId);
      const localVarPath = `/api/v1/search/catalog/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (query !== undefined) {
        localVarQueryParameter["query"] = query;
      }

      if (sku !== undefined) {
        localVarQueryParameter["sku"] = sku;
      }

      if (color !== undefined) {
        localVarQueryParameter["color"] = color;
      }

      if (model !== undefined) {
        localVarQueryParameter["model"] = model;
      }

      if (quality !== undefined) {
        localVarQueryParameter["quality"] = quality;
      }

      if (year !== undefined) {
        localVarQueryParameter["year"] = year;
      }

      if (campaign !== undefined) {
        localVarQueryParameter["campaign"] = campaign;
      }

      if (catalogId !== undefined) {
        localVarQueryParameter["catalogId"] = catalogId;
      }

      if (qrUrl !== undefined) {
        localVarQueryParameter["qrUrl"] = qrUrl;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search a product by query bypassing the cache
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProductWithoutCache: async (
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists("searchProductWithoutCache", "query", query);
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("searchProductWithoutCache", "storeId", storeId);
      const localVarPath = `/api/v1/search/no-cache/products/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (query !== undefined) {
        localVarQueryParameter["query"] = query;
      }

      if (minPrice !== undefined) {
        localVarQueryParameter["minPrice"] = minPrice;
      }

      if (maxPrice !== undefined) {
        localVarQueryParameter["maxPrice"] = maxPrice;
      }

      if (manualEntry !== undefined) {
        localVarQueryParameter["manualEntry"] = manualEntry;
      }

      if (minPublicationDateInMillis !== undefined) {
        localVarQueryParameter["minPublicationDateInMillis"] =
          minPublicationDateInMillis;
      }

      if (maxPublicationDateInMillis !== undefined) {
        localVarQueryParameter["maxPublicationDateInMillis"] =
          maxPublicationDateInMillis;
      }

      if (universeId) {
        localVarQueryParameter["universeId"] = universeId;
      }

      if (colorId) {
        localVarQueryParameter["colorId"] = colorId;
      }

      if (categoryId) {
        localVarQueryParameter["categoryId"] = categoryId;
      }

      if (sizeId) {
        localVarQueryParameter["sizeId"] = sizeId;
      }

      if (conditionId) {
        localVarQueryParameter["conditionId"] = conditionId;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SearchProductAPIApi - functional programming interface
 * @export
 */
export const SearchProductAPIApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SearchProductAPIApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProductById(
      id: number,
      storeId: number,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProductById(
        id,
        storeId,
        lang,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProductById1(
      id: number,
      storeId: number,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CatalogProductDetailDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProductById1(
        id,
        storeId,
        lang,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get filters for products
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId]
     * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProductSearchOptions(
      storeId: number,
      universeId?: number,
      showDisabled?: boolean,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SearchOptionsDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getProductSearchOptions(
          storeId,
          universeId,
          showDisabled,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get filters for products by gridId
     * @param {number} gridId
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProductSearchOptionsByGrid(
      gridId: number,
      storeId: number,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SearchOptionsDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getProductSearchOptionsByGrid(
          gridId,
          storeId,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get filters for products by universeId
     * @param {number} universeId
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProductSearchOptionsByUniverse(
      universeId: number,
      storeId: number,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SearchOptionsDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getProductSearchOptionsByUniverse(
          universeId,
          storeId,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get available products list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listAvailableProducts(
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listAvailableProducts(
          storeId,
          page,
          size,
          sort,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get available products list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listAvailableProducts1(
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageCatalogProductListDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listAvailableProducts1(
          storeId,
          page,
          size,
          sort,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get products by SKU list
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<string>} [skus]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listProductsBySku(
      storeId: number,
      skus?: Array<string>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageCatalogProductListDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listProductsBySku(
          storeId,
          skus,
          page,
          size,
          sort,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Search a product by query
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchProduct(
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchProduct(
        query,
        storeId,
        minPrice,
        maxPrice,
        manualEntry,
        minPublicationDateInMillis,
        maxPublicationDateInMillis,
        universeId,
        colorId,
        categoryId,
        sizeId,
        conditionId,
        page,
        size,
        sort,
        lang,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Search a product by query
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query]
     * @param {string} [sku]
     * @param {string} [color]
     * @param {string} [model]
     * @param {string} [quality]
     * @param {string} [year]
     * @param {string} [campaign]
     * @param {number} [catalogId]
     * @param {string} [qrUrl]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchProduct2(
      storeId: number,
      query?: string,
      sku?: string,
      color?: string,
      model?: string,
      quality?: string,
      year?: string,
      campaign?: string,
      catalogId?: number,
      qrUrl?: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageCatalogProductListDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchProduct2(
        storeId,
        query,
        sku,
        color,
        model,
        quality,
        year,
        campaign,
        catalogId,
        qrUrl,
        page,
        size,
        sort,
        lang,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Search a product by query bypassing the cache
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchProductWithoutCache(
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.searchProductWithoutCache(
          query,
          storeId,
          minPrice,
          maxPrice,
          manualEntry,
          minPublicationDateInMillis,
          maxPublicationDateInMillis,
          universeId,
          colorId,
          categoryId,
          sizeId,
          conditionId,
          page,
          size,
          sort,
          lang,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * SearchProductAPIApi - factory interface
 * @export
 */
export const SearchProductAPIApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SearchProductAPIApiFp(configuration);
  return {
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductById(
      id: number,
      storeId: number,
      lang?: string,
      options?: any,
    ): AxiosPromise<Product> {
      return localVarFp
        .getProductById(id, storeId, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a product by id
     * @param {number} id
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductById1(
      id: number,
      storeId: number,
      lang?: string,
      options?: any,
    ): AxiosPromise<CatalogProductDetailDto> {
      return localVarFp
        .getProductById1(id, storeId, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get filters for products
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId]
     * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductSearchOptions(
      storeId: number,
      universeId?: number,
      showDisabled?: boolean,
      lang?: string,
      options?: any,
    ): AxiosPromise<SearchOptionsDto> {
      return localVarFp
        .getProductSearchOptions(
          storeId,
          universeId,
          showDisabled,
          lang,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get filters for products by gridId
     * @param {number} gridId
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductSearchOptionsByGrid(
      gridId: number,
      storeId: number,
      lang?: string,
      options?: any,
    ): AxiosPromise<SearchOptionsDto> {
      return localVarFp
        .getProductSearchOptionsByGrid(gridId, storeId, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get filters for products by universeId
     * @param {number} universeId
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductSearchOptionsByUniverse(
      universeId: number,
      storeId: number,
      lang?: string,
      options?: any,
    ): AxiosPromise<SearchOptionsDto> {
      return localVarFp
        .getProductSearchOptionsByUniverse(universeId, storeId, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get available products list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAvailableProducts(
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageProduct> {
      return localVarFp
        .listAvailableProducts(storeId, page, size, sort, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get available products list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAvailableProducts1(
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageCatalogProductListDto> {
      return localVarFp
        .listAvailableProducts1(storeId, page, size, sort, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get products by SKU list
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<string>} [skus]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProductsBySku(
      storeId: number,
      skus?: Array<string>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageCatalogProductListDto> {
      return localVarFp
        .listProductsBySku(storeId, skus, page, size, sort, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search a product by query
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProduct(
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageProduct> {
      return localVarFp
        .searchProduct(
          query,
          storeId,
          minPrice,
          maxPrice,
          manualEntry,
          minPublicationDateInMillis,
          maxPublicationDateInMillis,
          universeId,
          colorId,
          categoryId,
          sizeId,
          conditionId,
          page,
          size,
          sort,
          lang,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search a product by query
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query]
     * @param {string} [sku]
     * @param {string} [color]
     * @param {string} [model]
     * @param {string} [quality]
     * @param {string} [year]
     * @param {string} [campaign]
     * @param {number} [catalogId]
     * @param {string} [qrUrl]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProduct2(
      storeId: number,
      query?: string,
      sku?: string,
      color?: string,
      model?: string,
      quality?: string,
      year?: string,
      campaign?: string,
      catalogId?: number,
      qrUrl?: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageCatalogProductListDto> {
      return localVarFp
        .searchProduct2(
          storeId,
          query,
          sku,
          color,
          model,
          quality,
          year,
          campaign,
          catalogId,
          qrUrl,
          page,
          size,
          sort,
          lang,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search a product by query bypassing the cache
     * @param {string} query
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [minPrice]
     * @param {number} [maxPrice]
     * @param {boolean} [manualEntry]
     * @param {number} [minPublicationDateInMillis]
     * @param {number} [maxPublicationDateInMillis]
     * @param {Array<number>} [universeId]
     * @param {Array<number>} [colorId]
     * @param {Array<number>} [categoryId]
     * @param {Array<number>} [sizeId]
     * @param {Array<number>} [conditionId]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProductWithoutCache(
      query: string,
      storeId: number,
      minPrice?: number,
      maxPrice?: number,
      manualEntry?: boolean,
      minPublicationDateInMillis?: number,
      maxPublicationDateInMillis?: number,
      universeId?: Array<number>,
      colorId?: Array<number>,
      categoryId?: Array<number>,
      sizeId?: Array<number>,
      conditionId?: Array<number>,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageProduct> {
      return localVarFp
        .searchProductWithoutCache(
          query,
          storeId,
          minPrice,
          maxPrice,
          manualEntry,
          minPublicationDateInMillis,
          maxPublicationDateInMillis,
          universeId,
          colorId,
          categoryId,
          sizeId,
          conditionId,
          page,
          size,
          sort,
          lang,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SearchProductAPIApi - interface
 * @export
 * @interface SearchProductAPIApi
 */
export interface SearchProductAPIApiInterface {
  /**
   *
   * @summary Get a product by id
   * @param {number} id
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  getProductById(
    id: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<Product>;

  /**
   *
   * @summary Get a product by id
   * @param {number} id
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  getProductById1(
    id: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<CatalogProductDetailDto>;

  /**
   *
   * @summary Get filters for products
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [universeId]
   * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  getProductSearchOptions(
    storeId: number,
    universeId?: number,
    showDisabled?: boolean,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<SearchOptionsDto>;

  /**
   *
   * @summary Get filters for products by gridId
   * @param {number} gridId
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  getProductSearchOptionsByGrid(
    gridId: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<SearchOptionsDto>;

  /**
   *
   * @summary Get filters for products by universeId
   * @param {number} universeId
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  getProductSearchOptionsByUniverse(
    universeId: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<SearchOptionsDto>;

  /**
   *
   * @summary Get available products list
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  listAvailableProducts(
    storeId: number,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageProduct>;

  /**
   *
   * @summary Get available products list
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  listAvailableProducts1(
    storeId: number,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageCatalogProductListDto>;

  /**
   *
   * @summary Get products by SKU list
   * @param {number} storeId ID of the store this query is directed to
   * @param {Array<string>} [skus]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  listProductsBySku(
    storeId: number,
    skus?: Array<string>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageCatalogProductListDto>;

  /**
   *
   * @summary Search a product by query
   * @param {string} query
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [minPrice]
   * @param {number} [maxPrice]
   * @param {boolean} [manualEntry]
   * @param {number} [minPublicationDateInMillis]
   * @param {number} [maxPublicationDateInMillis]
   * @param {Array<number>} [universeId]
   * @param {Array<number>} [colorId]
   * @param {Array<number>} [categoryId]
   * @param {Array<number>} [sizeId]
   * @param {Array<number>} [conditionId]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  searchProduct(
    query: string,
    storeId: number,
    minPrice?: number,
    maxPrice?: number,
    manualEntry?: boolean,
    minPublicationDateInMillis?: number,
    maxPublicationDateInMillis?: number,
    universeId?: Array<number>,
    colorId?: Array<number>,
    categoryId?: Array<number>,
    sizeId?: Array<number>,
    conditionId?: Array<number>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageProduct>;

  /**
   *
   * @summary Search a product by query
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [query]
   * @param {string} [sku]
   * @param {string} [color]
   * @param {string} [model]
   * @param {string} [quality]
   * @param {string} [year]
   * @param {string} [campaign]
   * @param {number} [catalogId]
   * @param {string} [qrUrl]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  searchProduct2(
    storeId: number,
    query?: string,
    sku?: string,
    color?: string,
    model?: string,
    quality?: string,
    year?: string,
    campaign?: string,
    catalogId?: number,
    qrUrl?: string,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageCatalogProductListDto>;

  /**
   *
   * @summary Search a product by query bypassing the cache
   * @param {string} query
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [minPrice]
   * @param {number} [maxPrice]
   * @param {boolean} [manualEntry]
   * @param {number} [minPublicationDateInMillis]
   * @param {number} [maxPublicationDateInMillis]
   * @param {Array<number>} [universeId]
   * @param {Array<number>} [colorId]
   * @param {Array<number>} [categoryId]
   * @param {Array<number>} [sizeId]
   * @param {Array<number>} [conditionId]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApiInterface
   */
  searchProductWithoutCache(
    query: string,
    storeId: number,
    minPrice?: number,
    maxPrice?: number,
    manualEntry?: boolean,
    minPublicationDateInMillis?: number,
    maxPublicationDateInMillis?: number,
    universeId?: Array<number>,
    colorId?: Array<number>,
    categoryId?: Array<number>,
    sizeId?: Array<number>,
    conditionId?: Array<number>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageProduct>;
}

/**
 * SearchProductAPIApi - object-oriented interface
 * @export
 * @class SearchProductAPIApi
 * @extends {BaseAPI}
 */
export class SearchProductAPIApi
  extends BaseAPI
  implements SearchProductAPIApiInterface
{
  /**
   *
   * @summary Get a product by id
   * @param {number} id
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public getProductById(
    id: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .getProductById(id, storeId, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a product by id
   * @param {number} id
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public getProductById1(
    id: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .getProductById1(id, storeId, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get filters for products
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [universeId]
   * @param {boolean} [showDisabled] True by default. Set to false to show enabled options only.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public getProductSearchOptions(
    storeId: number,
    universeId?: number,
    showDisabled?: boolean,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .getProductSearchOptions(storeId, universeId, showDisabled, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get filters for products by gridId
   * @param {number} gridId
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public getProductSearchOptionsByGrid(
    gridId: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .getProductSearchOptionsByGrid(gridId, storeId, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get filters for products by universeId
   * @param {number} universeId
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public getProductSearchOptionsByUniverse(
    universeId: number,
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .getProductSearchOptionsByUniverse(universeId, storeId, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get available products list
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public listAvailableProducts(
    storeId: number,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .listAvailableProducts(storeId, page, size, sort, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get available products list
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public listAvailableProducts1(
    storeId: number,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .listAvailableProducts1(storeId, page, size, sort, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get products by SKU list
   * @param {number} storeId ID of the store this query is directed to
   * @param {Array<string>} [skus]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public listProductsBySku(
    storeId: number,
    skus?: Array<string>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .listProductsBySku(storeId, skus, page, size, sort, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search a product by query
   * @param {string} query
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [minPrice]
   * @param {number} [maxPrice]
   * @param {boolean} [manualEntry]
   * @param {number} [minPublicationDateInMillis]
   * @param {number} [maxPublicationDateInMillis]
   * @param {Array<number>} [universeId]
   * @param {Array<number>} [colorId]
   * @param {Array<number>} [categoryId]
   * @param {Array<number>} [sizeId]
   * @param {Array<number>} [conditionId]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public searchProduct(
    query: string,
    storeId: number,
    minPrice?: number,
    maxPrice?: number,
    manualEntry?: boolean,
    minPublicationDateInMillis?: number,
    maxPublicationDateInMillis?: number,
    universeId?: Array<number>,
    colorId?: Array<number>,
    categoryId?: Array<number>,
    sizeId?: Array<number>,
    conditionId?: Array<number>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .searchProduct(
        query,
        storeId,
        minPrice,
        maxPrice,
        manualEntry,
        minPublicationDateInMillis,
        maxPublicationDateInMillis,
        universeId,
        colorId,
        categoryId,
        sizeId,
        conditionId,
        page,
        size,
        sort,
        lang,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search a product by query
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [query]
   * @param {string} [sku]
   * @param {string} [color]
   * @param {string} [model]
   * @param {string} [quality]
   * @param {string} [year]
   * @param {string} [campaign]
   * @param {number} [catalogId]
   * @param {string} [qrUrl]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public searchProduct2(
    storeId: number,
    query?: string,
    sku?: string,
    color?: string,
    model?: string,
    quality?: string,
    year?: string,
    campaign?: string,
    catalogId?: number,
    qrUrl?: string,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .searchProduct2(
        storeId,
        query,
        sku,
        color,
        model,
        quality,
        year,
        campaign,
        catalogId,
        qrUrl,
        page,
        size,
        sort,
        lang,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search a product by query bypassing the cache
   * @param {string} query
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [minPrice]
   * @param {number} [maxPrice]
   * @param {boolean} [manualEntry]
   * @param {number} [minPublicationDateInMillis]
   * @param {number} [maxPublicationDateInMillis]
   * @param {Array<number>} [universeId]
   * @param {Array<number>} [colorId]
   * @param {Array<number>} [categoryId]
   * @param {Array<number>} [sizeId]
   * @param {Array<number>} [conditionId]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchProductAPIApi
   */
  public searchProductWithoutCache(
    query: string,
    storeId: number,
    minPrice?: number,
    maxPrice?: number,
    manualEntry?: boolean,
    minPublicationDateInMillis?: number,
    maxPublicationDateInMillis?: number,
    universeId?: Array<number>,
    colorId?: Array<number>,
    categoryId?: Array<number>,
    sizeId?: Array<number>,
    conditionId?: Array<number>,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchProductAPIApiFp(this.configuration)
      .searchProductWithoutCache(
        query,
        storeId,
        minPrice,
        maxPrice,
        manualEntry,
        minPublicationDateInMillis,
        maxPublicationDateInMillis,
        universeId,
        colorId,
        categoryId,
        sizeId,
        conditionId,
        page,
        size,
        sort,
        lang,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SearchStoreAPIApi - axios parameter creator
 * @export
 */
export const SearchStoreAPIApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Get Store info
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStoreInfo: async (
      storeId: number,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("getStoreInfo", "storeId", storeId);
      const localVarPath = `/api/v1/search/store`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SearchStoreAPIApi - functional programming interface
 * @export
 */
export const SearchStoreAPIApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SearchStoreAPIApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get Store info
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStoreInfo(
      storeId: number,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreInfoDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getStoreInfo(
        storeId,
        lang,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * SearchStoreAPIApi - factory interface
 * @export
 */
export const SearchStoreAPIApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SearchStoreAPIApiFp(configuration);
  return {
    /**
     *
     * @summary Get Store info
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStoreInfo(
      storeId: number,
      lang?: string,
      options?: any,
    ): AxiosPromise<StoreInfoDto> {
      return localVarFp
        .getStoreInfo(storeId, lang, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SearchStoreAPIApi - interface
 * @export
 * @interface SearchStoreAPIApi
 */
export interface SearchStoreAPIApiInterface {
  /**
   *
   * @summary Get Store info
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchStoreAPIApiInterface
   */
  getStoreInfo(
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<StoreInfoDto>;
}

/**
 * SearchStoreAPIApi - object-oriented interface
 * @export
 * @class SearchStoreAPIApi
 * @extends {BaseAPI}
 */
export class SearchStoreAPIApi
  extends BaseAPI
  implements SearchStoreAPIApiInterface
{
  /**
   *
   * @summary Get Store info
   * @param {number} storeId ID of the store this query is directed to
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchStoreAPIApi
   */
  public getStoreInfo(
    storeId: number,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchStoreAPIApiFp(this.configuration)
      .getStoreInfo(storeId, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SearchUniverseAPIApi - axios parameter creator
 * @export
 */
export const SearchUniverseAPIApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Get universes list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUniverses: async (
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("listUniverses", "storeId", storeId);
      const localVarPath = `/api/v1/search/universes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SearchUniverseAPIApi - functional programming interface
 * @export
 */
export const SearchUniverseAPIApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SearchUniverseAPIApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get universes list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listUniverses(
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageUniverseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listUniverses(
        storeId,
        page,
        size,
        sort,
        lang,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * SearchUniverseAPIApi - factory interface
 * @export
 */
export const SearchUniverseAPIApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SearchUniverseAPIApiFp(configuration);
  return {
    /**
     *
     * @summary Get universes list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUniverses(
      storeId: number,
      page?: number,
      size?: number,
      sort?: Array<string>,
      lang?: string,
      options?: any,
    ): AxiosPromise<PageUniverseDto> {
      return localVarFp
        .listUniverses(storeId, page, size, sort, lang, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SearchUniverseAPIApi - interface
 * @export
 * @interface SearchUniverseAPIApi
 */
export interface SearchUniverseAPIApiInterface {
  /**
   *
   * @summary Get universes list
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchUniverseAPIApiInterface
   */
  listUniverses(
    storeId: number,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ): AxiosPromise<PageUniverseDto>;
}

/**
 * SearchUniverseAPIApi - object-oriented interface
 * @export
 * @class SearchUniverseAPIApi
 * @extends {BaseAPI}
 */
export class SearchUniverseAPIApi
  extends BaseAPI
  implements SearchUniverseAPIApiInterface
{
  /**
   *
   * @summary Get universes list
   * @param {number} storeId ID of the store this query is directed to
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {string} [lang] ISO 639-1 code for the desired response language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchUniverseAPIApi
   */
  public listUniverses(
    storeId: number,
    page?: number,
    size?: number,
    sort?: Array<string>,
    lang?: string,
    options?: AxiosRequestConfig,
  ) {
    return SearchUniverseAPIApiFp(this.configuration)
      .listUniverses(storeId, page, size, sort, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
